<template>
    <list class="m-0 p-0"
          v-model="queries"
          :columns="columns"
          :pagination="pagination"
          :loading="pagination.loading"
          :on-change-page="changePage"
          :actionsByRow="true"
          :actions="[]"
          :hideAverage="processed">
        <template slot="header">
            <fg-input class="pl-3 pt-2 pb-2 btn-one-size-dropdown">
                <el-select size="large"
                           class="select-primary"
                           @change="filterChange"
                           v-model="processed">
                    <el-option v-for="option in [{value: false, label: 'Open'}, {value: true, label: 'Completed'}]"
                               :value="option.value"
                               :label="$t(option.label)"
                               :key="option.value">
                    </el-option>
                </el-select>
            </fg-input>
        </template>
        <template slot="average" slot-scope="props">
          <div>
            <status-indicator class="mr-1"
                              :value="props.row.accumulation.fullAverage"
                              :precision="1"/>
          </div>
        </template>
        <template slot="actionsByRow" slot-scope="props">
            <p-button v-if="props.row.processed" round type="success" size="sm" icon @click="$router.push({ name: 'QueryResult', params: { id: props.row._id } })">
                <i class="fa fa-eye"/>
            </p-button>
            <p-button v-else round type="primary" size="sm" icon @click="$router.push({ name: 'QueryAnswer', params: { id: props.row._id } })">
                <i class="fa fa-edit"/>
            </p-button>
        </template>
    </list>
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex'
  import { Select, Option } from 'element-ui'
  import List from '../../Dashboard/Components/BasicList'
  import OpinionSlider from 'src/components/Dashboard/Components/OpinionSlider'
  import StatusIndicator from '../../Dashboard/Components/StatusIndicator'

  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [OpinionSlider.name]: OpinionSlider,
      List,
      StatusIndicator
    },
    data () {
      return {
        processed: false,
        sf: 'createdAt',
        so: 'desc',
        columns: [
          { name: 'createdAt', text: 'Date', sortable: false, align: 'left', formatter: this.dateFormatter, minWidth: 150 },
          { name: 'title', text: 'Title', sortable: false, align: 'left', formatter: this.languageFormatter, minWidth: 150 },
          { name: 'status', text: 'Status', sortable: false, align: 'left', formatter: this.statusFormatter,  minWidth: 150 }
        ]
      }
    },
    async mounted () {
      const { search } = this.pagination
      if (search.hasOwnProperty('processed')) {
        this.processed = search.processed
      }

      this.init()
    },
    computed: {
      ...mapGetters({ getSortedItems: 'user/queries/getSortedItems' }),
      ...mapState('user/queries', {
        pagination: ({ items, ...rest }) => rest
      }),
      queries: function () {
        return this.getSortedItems
      },
    },
    methods: {
      async init () {
        const newPage = parseInt(this.pagination.page, 10) || 1
        await this.getList({ perPage: this.pagination.perPage, page: newPage, sf: this.sf, so: this.so, search: { processed: this.processed } })
      },
      languageFormatter: function (row, column, cellValue) {
        return this.$options.filters.languageString(cellValue)
      },
      dateFormatter: function (row, column, cellValue) {
        return this.$options.filters.formatDate(cellValue)
      },
      statusFormatter: function (row) {
        if (row.processed) {
          if (row.answers.length === 0) {
            return this.$t('Not Completed')
          } else {
            return this.$t('Completed')
          }
        } else {
          if (row.completed) {
            return this.$t('In Progress')
          } else {
            return this.$t('Open')
          }
        }
      },
      filterChange: function () {
        this.init()
      },
      ...mapActions('user/queries', ['getList', 'getItem', 'changePage'])
    },
    watch: {
      'pagination.page' (newVal, oldVal) {
        if (newVal !== oldVal) {
            this.init()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @media (max-width: 590px) {
    .btn-one-size-dropdown {
      width: 100%;
      padding-left: 0px;
      padding-right: 0px;
      padding-right: 15px !important;
    }
  }
</style>

